module.exports = __webpack_public_path__ + "media/images/bg/hero/saska-school-0dec6301805523e687a748fc3a98430d.jpg";